import React from 'react';
import { connect } from 'react-redux';
import FrontLayout from '../containers/FrontLayout';
import LoginContent from '../components/Front/LoginContent';

// Implement JWT

const Home = ({ site }) => {
  return (
    <FrontLayout 
      title="YOUR SIGN-IN INFORMATION" 
      seoTitle={site?.site_name ? `User Login | ${site?.site_name || ''}` : ''}
    >
      <LoginContent page='login' />
    </FrontLayout>
  )
}

const mapStateToProps = state => {
  return {
    site: state.site
  }
}

export default connect(mapStateToProps, null)(Home)